import { Media } from "../interfaces/api/get-social-posts";
import { PostImage } from "../interfaces/postImage";
import { PostVideo } from "../interfaces/postVideo";

async function mediaUrlToPostImage(
  m: Media,
  index: number
): Promise<PostImage | null> {
  if (!m.url) return null;
  const blob = await fetch(m.url).then((r) => r.blob());
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
  return {
    id: m.key || `media-${index}`,
    lastModified: Date.now(),
    name: m.key || `media-${index}`,
    size: blob.size,
    type: blob.type || "image/jpeg",
    data: dataUrl,
  };
}

/** Convierte medios ya guardados (URLs) en PostImage con data URI para FormData / APIs. */
export async function loadPostImagesFromMediaUrls(
  media: Media[] | Media
): Promise<PostImage[]> {
  const items = Array.isArray(media) ? media : media ? [media] : [];
  const results = await Promise.all(
    items.map((m, i) => mediaUrlToPostImage(m, i))
  );
  return results.filter((x): x is PostImage => x != null);
}

export async function loadPostVideoFromMediaUrl(
  media: Media[] | Media
): Promise<PostVideo | null> {
  const items = Array.isArray(media) ? media : media ? [media] : [];
  const m = items.find((x) => x.url) || items[0];
  if (!m?.url) return null;
  const blob = await fetch(m.url).then((r) => r.blob());
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
  return {
    id: m.key || "video",
    lastModified: Date.now(),
    name: "video",
    size: blob.size,
    type: blob.type || "video/mp4",
    data: dataUrl,
    duration: 0,
  };
}
